import { useTranslation } from "react-i18next";

const DisputCards = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  2xl:grid-cols-5 gap-5">
      <div className="rounded-2xl p-6 [background:var(--gradient-primary)] ">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-3 items-center text-white font-bold text-xl">
            <h3>{t("admin.inProgress")}</h3>
            <p>{data?.in_processing}</p>
          </div>
          <img src="/img/progress.svg" alt="" />
        </div>
      </div>
      <div className="rounded-2xl p-6 [background:var(--gradient-primary)] ">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-3 items-center text-white font-bold text-xl">
            <h3>{t("admin.open")}</h3>
            <p>{data?.open}</p>
          </div>
          <img src="/img/open.svg" alt="" />
        </div>
      </div>
      <div className="rounded-2xl p-6 [background:var(--gradient-primary)] ">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-3 items-center text-white font-bold text-xl">
            <h3>{t("admin.rejected")}</h3>
            <p>{data?.rejected}</p>
          </div>
          <img src="/img/progress.svg" alt="" />
        </div>
      </div>
      <div className="rounded-2xl p-6 [background:var(--gradient-primary)] ">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-3 items-center text-white font-bold text-xl">
            <h3>{t("admin.underReview")}</h3>
            <p>{data?.under_review}</p>
          </div>
          <img src="/img/open.svg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default DisputCards;
